export const technicalSheet = {
	sections: {
		generalInfo: {
			title: "INFORMATIONS GÉNÉRALES",
			preparationTime: {
				label: "Temps de préparation",
				placeholder: "00 minutes",
				unit: "minutes",
			},
		},
		ingredients: {
			title: "INGRÉDIENTS",
			addButton: "Ajouter à la fiche",
			emptyState: {
				title: "Aucun ingrédient ajouté",
				message: "Ajoutez des ingrédients pour composer la fiche technique",
			},
			inline: {
				product: "Produit/Ingrédient",
				quantity: "Quantité",
				loss: "Pertes",
			},
			columns: {
				product: "PRODUIT/INGRÉDIENT",
				quantity: "QUANTITÉ",
				loss: "PERTE",
				yield: "RENDEMENT",
				unitCost: "COÛT UNT.",
				unitCostTooltip: "Le coût unitaire est la moyenne de tous les coûts du produit",
				totalCost: "COÛT TOTAL",
				totalCostTooltip: "Le coût total est le coût moyen de tous les produits",
			},
			validation: {
				selectProduct: "Sélectionnez un ingrédient",
				addQuantity: "Ajoutez une quantité",
				lossGreaterThanQuantity:
					"La valeur de perte ne peut pas être supérieure à la quantité",
				atLeastOneIngredient: "Ajoutez au moins un ingrédient à la fiche technique",
				quantityGreaterThanZero: "La valeur doit être supérieure à 0",
			},
		},
	},
	summary: {
		salePrice: "Prix de vente",
		totalCost: "Coût total",
		totalCostTooltip: "Le coût total est le coût moyen de tous les produits",
		profitMargin: "Marge bénéficiaire",
		cmv: "CMV",
	},
	actions: {
		delete: "Supprimer la fiche technique",
		exportPdf: "Exporter en PDF",
		deleteConfirmation: {
			title: "Supprimer la fiche technique",
			description:
				"En confirmant cette action, vous supprimez définitivement la fiche technique. Voulez-vous continuer ?",
			confirm: "Oui, je veux supprimer",
			cancel: "Annuler",
		},
		notifications: {
			deleteSuccess: "Fiche technique supprimée avec succès",
			deleteError: "Erreur lors de la suppression de la fiche technique",
		},
	},
};
